/** Event that will be emitted on {@link document} when the mock DB code changes */
export const event_mockDbHotReload = "mockDbHotReload";
/** Notify front-end to eg. clear query caches */
export function notifyMockDbHotReload() {
    document.dispatchEvent(new Event(event_mockDbHotReload));
}
